import {
  FACILITY_HISTORY_SAVE, FACILITY_HISTORY_IMAGE_SAVE, FACILITY_HISTORY_SAVE_FAILURE, FACILITY_HISTORY_SAVE_SUCCESS,
  FACILITY_HISTORY_GET, FACILITY_HISTORY_GET_SUCCESS, FACILITY_HISTORY_GET_FAILURE,
  FACILITY_HISTORY_SEARCH, FACILITY_HISTORY_SEARCH_SUCCESS, FACILITY_HISTORY_SEARCH_FAILURE,
  FACILITY_HISTORY_SELECT, FACILITY_DUPLICATE_CHECK, FACILITY_DUPLICATE_CHECK_SUCCESS, FACILITY_DUPLICATE_CHECK_FAILURE,
  FACILITY_CODE_DUPLICATE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    facilityHistories: null,
    currentFacilityHistoryId: null,
    selectedFacilityIds: null,
    facilityEditNotify: null
  },
  getters: {
    facilityHistories: state => {
      return state.facilityHistories
    },
    currentFacilityHistoryId: state => {
      return state.currentFacilityHistoryId
    },
    selectedFacilityIds: state => {
      return state.selectedFacilityIds
    },
    selectedFacilityHistoryId: state => {
      return state.selectedFacilityHistoryId
    },
    /** 通知 */
    facilityEditNotify: state => {
      return state.facilityEditNotify
    }
  },
  actions: {
    [FACILITY_HISTORY_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/facility_histories'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_SEARCH_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_SEARCH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [FACILITY_HISTORY_GET] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/get'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_GET_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_GET_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** 電話番号入力チェック */
    [FACILITY_DUPLICATE_CHECK] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/duplicate_check'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_DUPLICATE_CHECK_FAILURE, res.data)
            } else {
              commit(FACILITY_DUPLICATE_CHECK_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [FACILITY_HISTORY_SAVE] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/save'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_SAVE_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_SAVE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [FACILITY_HISTORY_IMAGE_SAVE] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/image_save'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_SAVE_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_SAVE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [FACILITY_HISTORY_SELECT] ({state, commit}, params) {
      commit(FACILITY_HISTORY_SELECT, params)
    },
    [FACILITY_CODE_DUPLICATE] ({state, commit}, params) {
      commit(FACILITY_CODE_DUPLICATE, params)
    }
  },
  mutations: {
    [FACILITY_HISTORY_SEARCH_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_SEARCH_FAILURE')
      // 通知
      state.facilityEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.facilityEditNotify = null
      }, constant.notifyShowTime.normal)
    },
    [FACILITY_HISTORY_SEARCH_SUCCESS] (state, data) {
      console.log('FACILITY_HISTORY_SEARCH_SUCCESS')
      state.facilityHistories = data.data.data
      state.currentFacilityHistoryId = data.data.meta['current-facility-history-id']
      if (data.callback !== null) {
        data.callback(state.currentFacilityHistoryId)
      }
    },
    [FACILITY_HISTORY_GET_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_GET_FAILURE')
    },
    [FACILITY_HISTORY_GET_SUCCESS] (state, data) {
      console.log('FACILITY_HISTORY_GET_SUCCESS')

      data.callback(data.data)
    },
    [FACILITY_HISTORY_SAVE_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_SAVE_FAILURE')
      // 通知
      state.facilityEditNotify = {
        danger: true,
        message_i18n: data.error
      }
      setTimeout(() => {
        state.facilityEditNotify = null
      }, constant.notifyShowTime.normal)
    },
    [FACILITY_HISTORY_SAVE_SUCCESS] (state, data) {
      console.log('FACILITY_HISTORY_SAVE_SUCCESS')
      // 完了
      state.facilityEditNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.facilityEditNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback !== null) {
        data.callback()
      }
    },
    [FACILITY_DUPLICATE_CHECK_FAILURE] (state, data) {
      console.log('FACILITY_DUPLICATE_CHECK_FAILURE')
    },
    [FACILITY_DUPLICATE_CHECK_SUCCESS] (state, data) {
      console.log('FACILITY_DUPLICATE_CHECK_SUCCESS')
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [FACILITY_HISTORY_SELECT] (state, data) {
      console.log('FACILITY_HISTORY_SELECT')
      state.selectedFacilityHistoryId = data.selected_facility_history_id
      if (data.callback !== null) {
        data.callback()
      }
    },
    [FACILITY_CODE_DUPLICATE] (state, data) {
      console.log('FACILITY_CODE_DUPLICATE')
      // 重複
      state.facilityEditNotify = {
        danger: true,
        message_i18n: 'messages.save.floor_code_duplicate'
      }
      setTimeout(() => {
        state.facilityEditNotify = null
      }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/facility-history.js